import "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import { formatSpecification } from "../../../shared/lib/format/specification/formatSpecifications.js";
import "../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
function formatSpecifications(data, options = { onlyDifferences: false }) {
  const { vehicleItems, schemes } = data;
  const { onlyDifferences = false } = options;
  return schemes.reduce((acc, item) => {
    const items = vehicleItems.map((car) => formatSpecification(car, item));
    if (items.every((item2) => !item2)) {
      return acc;
    }
    if (onlyDifferences && items.length > 1 && new Set(items.map((item2) => item2 == null ? void 0 : item2.value)).size < 2) {
      return acc;
    }
    return [...acc, items];
  }, []);
}
export {
  formatSpecifications
};
